import { CustomerService } from 'src/app/services/customer/customer.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { Subscription, Observable } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import * as _ from 'lodash';
import { RegexEnum } from 'src/app/core/enum/regex.enum';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateCustomerComponent implements OnInit { // NEED TO CLEAN ALL THE UPDATE AND CREATE FILES, NEED TO MAKE THEM ONE REUSABLE COMPONENT FOR ALL TYPES.
  public customer: {};
  private redirectUrl;
  public organization_id: string;
  public customerUserID: string;
  public customerId: string;
  public customerUpdate: {} = { organizationCode: '', organizationName: '' };
  private sub: any;
  public userType: string = 'user';
  public viewOnly: boolean = false;
  public loading: boolean = false;
  public roleLoading: boolean = false;
  public privileges: {} = {
    HC_CUSTOMER_TRACKTRACE: false, HC_CUSTOMER_UNYSON_TRACKTRACE: false,
    HC_CUSTOMER_ANALYTICS: false, HC_CUSTOMER_RATEREQUEST: false,
    HC_CUSTOMER_CREATE_ORDER: false, HC_CUSTOMER_CLAIMS: false,
    HC_CUSTOMER_CREATE_USER: false, HC_CUSTOMER_DELETE_USER: false,
    HC_CUSTOMER_UPDATE_USER: false, HC_CUSTOMER_VIEW_USER: false,
    HC_CUSTOMER_RATE_INQUIRY: false
  };
  public userManagement: boolean = false;
  public originLimitations: boolean = false;
  public destinationLimitations: boolean = false;
  public isAdhoc: boolean = false;
  public currentUserRole: string = '';
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public roleOptions: object[] = [];
  public customerUserRole: {} = {
    value: 'HC_CUSTOMER_USER',
    name: 'Customer User',
    description: 'A customer user can access the customer portal, view load details, and manage most customer actions. They cannot create or manage other users of the portal.'
  };
  public customerClaimsRole: {} = {
    value: 'HC_CUSTOMER_CLAIMS_USER',
    name: 'Customer Claims Role',
    description: 'A customer claims user is a predefined role with access to the portal with the following privileges track and trace and create claim event.'
  };
  public customerCustomRole: {} = {
    value: 'HC_CUSTOMER_ADHOC',
    name: 'Customer Custom Role',
    description: 'A customer user that has specifically defined privileges to the customer portal'
  };
  public customerAdminRole: {} = {
    value: 'HC_CUSTOMER_ADMIN',
    name: 'Customer Admin',
    description: 'Customer admins can access the entire customer portal as well as create and manage users of their portal. They can also manage privileges and access.'
  };
  public regexEnum = RegexEnum;

  constructor(public currentUserService: CurrentUserService, public customerService: CustomerService,
    private route: ActivatedRoute, private router: Router,
    private flashMessageService: FlashMessageService,
    private cdRef: ChangeDetectorRef, private _dropdownService: DropdownService) { }

  ngOnInit() {
    this.loading = true;
    this.customerService.resetUpdateUser();
    this.customerService.nameIsInvalid = false;
    if (!this.currentUserService.user) {
      this.router.navigate(['../../users'], { relativeTo: this.route });
      return false;
    }

    if (this.currentUserService.isInternal && !this.customerService.all.length) {
      this.loading = true;
      this.customerService.getCustomers().then(() => {
        this.loading = false;
      });
    }

    if (this.currentUserService.entitlements['HC_CUSTOMER_VIEW_USER'] && !this.currentUserService.entitlements['HC_CUSTOMER_UPDATE_USER']) {
      this.viewOnly = true;
    }

    this.sub = this.route.queryParams.subscribe(params => {
      this.customerUserID = params['ID'];
      this.customerId = params['customerID'];
      this.customerService.currentCustomerID_.next(params['customerID']);
      this.redirectUrl = params['urlPath'];

      this.customerUpdate['organizationCode'] = params['customerID'];
      this.customerService.updatedCustomerUser.organization.organizationCode = params['customerID'];
      this.customerService.currentCustomerID = params['customerID'];

      if (this.currentUserService.user.role.type.toLowerCase() === 'customer') {
        this.customerService.updatedCustomerUser.organization_id = this.currentUserService.user.organizationCode;
        this.customerId = this.currentUserService.user.organizationCode;
      } else {
        if (this.customerService.all.length) {
          this.customerUpdate = this.customerService.getCustomer(params['customerID']);
        } else {
          this.customerService.getCustomers().then(() => {
            this.customerUpdate = this.customerService.getCustomer(params['customerID']);
          });
        }
      }

      if (params['ID'] && !params['edit']) {
        this.customerService.getCustomerUser(this.customerUserID).then((resp) => {
          this.customerService.updatedCustomerUser.name = resp['firstname'] + " " + resp['lastname'];
          this.customerService.updatedCustomerUser.email = resp['email'];
          this.customerService.updatedCustomerUser.phone = resp['phone'];
          this.customerService.updatedCustomerUser.mobile_phone = resp['alternatePhone'];
          this.customerService.updatedCustomerUser.registeredDate = resp['registeredDate'];

          if (resp['allowed_origin_locations']) {
            this.customerService.updatedCustomerUser.allowed_origin_locations = resp['allowed_origin_locations'];
            this.customerService.updatedCustomerUser.allowed_origin_locations_display = this._formatLocation(resp['allowed_origin_locations']);
          } else {
            this.customerService.updatedCustomerUser.allowed_origin_locations = {};
            this.customerService.updatedCustomerUser.allowed_origin_locations_display = [];
          }

          if (resp['allowed_destination_locations']) {
            this.customerService.updatedCustomerUser.allowed_destination_locations = resp['allowed_destination_locations'];
            this.customerService.updatedCustomerUser.allowed_destination_locations_display = this._formatLocation(resp['allowed_destination_locations']);
          } else {
            this.customerService.updatedCustomerUser.allowed_destination_locations = {};
            this.customerService.updatedCustomerUser.allowed_destination_locations_display = [];
          }

          this.customerService.updatedCustomerUser.roleCode = resp['applications'][0]['roleCode'];
          if (this.customerService.updatedCustomerUser.roleCode === "HC_CUSTOMER_ADHOC") {
            this.isAdhoc = true;
            resp['entitlements'].entitlements.forEach((p) => {
              this.matchPrivileges(p.code);
            })
          }
          else { //apparently adhoc entitlements are nested and regular users arent, need to fix!
            resp['entitlements'].forEach((p) => {
              this.matchPrivileges(p.code);
            })
          }

          this.loading = false;
        })
          .catch((error) => {
            this.loading = false;
            if (error.status = 401) {
              this.flashMessageService.updateMessage('You are not Authorized to access this User');
            }
            this.router.navigate(['../../users/all'], { relativeTo: this.route });
          });

        this._loadCustomerDetails(this.customerId);
      } else if (params['edit']) {
        this.customerService.updatedCustomerUser.name = params['name'];
        this.customerService.updatedCustomerUser.email = params['email'];
        this.customerService.updatedCustomerUser.phone = params['phone'];
        this.customerService.updatedCustomerUser.organization.organizationCode = params['customerID'];
        this.customerService.updatedCustomerUser.organization.organizationName = params['organization'];
        this.customerService.updatedCustomerUser.registeredDate = params['registeredDate'];
        if (params['mobile'] == "null" || params['mobile'] == 'undefined') {
          this.customerService.updatedCustomerUser.mobile_phone = null;
        } else {
          this.customerService.updatedCustomerUser.mobile_phone = params['mobile'];
        }
        this.customerService.updatedCustomerUser.roleCode = params['userType'];
        params['entitlements'].forEach((p) => {
          this.matchPrivileges(p);
        })

        this._repopulateGeoLimitations('origins', params);
        this._repopulateGeoLimitations('destinations', params);

        if (this.customerService.updatedCustomerUser.roleCode === "HC_CUSTOMER_ADHOC") {
          this.isAdhoc = true;
        }
        this._loadCustomerDetails(this.customerService.updatedCustomerUser.organization['organizationCode']);
      } else {
        this.router.navigate(['../../'], { relativeTo: this.route });
      }
    });
    this.assignRoleValues(this.customerId);
  }

  private _repopulateGeoLimitations(type: string, params: any) {
    if (type === 'origins') {
      if (params['origins'] != undefined && params['origins'].length) {
        this.originLimitations = true;
        this.customerService.newCustomerUser.allowed_origin_locations = params['origins'].constructor == String ? [params['origins']] : params['origins'];
      } else {
        this.customerService.newCustomerUser.allowed_origin_locations = [];
      }
    }
    else {
      if (params['destinations'] != undefined && params['destinations'].length) {
        this.destinationLimitations = true;
        this.customerService.newCustomerUser.allowed_destination_locations = params['destinations'].constructor == String ? [params['destinations']] : params['destinations'];
      } else {
        this.customerService.newCustomerUser.allowed_destination_locations = [];
      }
    }
  }

  public assignRoleValues(id: string = null) {
    this.roleOptions = [];
    this.customerId = id ? id : null;
    this.roleLoading = true;
    this.customerService.getOrganizationRoles(this.customerId).then((organizationRoles: []) => {

      if (this.currentUserService.user.role.code == "HC_CUSTOMER_ADMIN") {
        this.currentUserRole = 'customerAdmin';
      }

      if (this.currentUserService.isInternal) {
        this.currentUserRole = 'hubAdmin';
        setTimeout(this._customerSearchSetup.bind(this), 50);
      }

      if ((!organizationRoles || !organizationRoles.length) && this.customerId) {
        this.roleOptions = [this.customerUserRole, this.customerClaimsRole, this.customerCustomRole, this.customerAdminRole];
      } else {
        organizationRoles.forEach((role: any) => {
          if (role.enabled) {
            switch (role.roleCode) {
              case 'HC_CUSTOMER_ADMIN':
                this.roleOptions.push(this.customerAdminRole);
                break;
              case 'HC_CUSTOMER_USER':
                this.roleOptions.push(this.customerUserRole);
                break;
              case 'HC_CUSTOMER_CLAIMS_USER':
                this.roleOptions.push(this.customerClaimsRole);
                break;
              case 'HC_CUSTOMER_ADHOC':
                this.roleOptions.push(this.customerCustomRole);
                break;
            };
          }
        });
      }
      this.roleLoading = false;
    }).catch(() => this.roleLoading = false);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public matchPrivileges(privilege) {
    this.privileges[privilege] = true;

    if (privilege == "HC_CUSTOMER_CREATE_USER" || privilege == "HC_CUSTOMER_DELETE_USER" ||
      privilege == "HC_CUSTOMER_UPDATE_USER" || privilege == "HC_CUSTOMER_VIEW_USER") {
      this.userManagement = true;
    }
  }

  public setupPrivileges() {
    if (this.customerService.updatedCustomerUser.roleCode == "HC_CUSTOMER_ADMIN") {
      this.isAdhoc = false;
      this.privileges['HC_CUSTOMER_TRACKTRACE'] = true;
      this.privileges['HC_CUSTOMER_UNYSON_TRACKTRACE'] = true;
      this.privileges['HC_CUSTOMER_RATEREQUEST'] = true;
      this.privileges['HC_CUSTOMER_RATE_INQUIRY'] = false;
      this.privileges['HC_CUSTOMER_CREATE_ORDER'] = true;
      this.privileges['HC_CUSTOMER_CLAIMS'] = true;
      this.privileges['HC_CUSTOMER_ANALYTICS'] = true;
      this.privileges['HC_CUSTOMER_CREATE_USER'] = true;
      this.privileges['HC_CUSTOMER_DELETE_USER'] = true;
      this.privileges['HC_CUSTOMER_UPDATE_USER'] = true;
      this.privileges['HC_CUSTOMER_VIEW_USER'] = true;
      this.userManagement = true;
      this.destinationLimitations = false;
      this.originLimitations = false;
    } else if (this.customerService.updatedCustomerUser.roleCode == "HC_CUSTOMER_USER") {
      this.isAdhoc = false;
      this.privileges['HC_CUSTOMER_TRACKTRACE'] = true;
      this.privileges['HC_CUSTOMER_UNYSON_TRACKTRACE'] = true;
      this.privileges['HC_CUSTOMER_RATEREQUEST'] = true;
      this.privileges['HC_CUSTOMER_RATE_INQUIRY'] = false;
      this.privileges['HC_CUSTOMER_CREATE_ORDER'] = true;
      this.privileges['HC_CUSTOMER_CLAIMS'] = false;
      this.privileges['HC_CUSTOMER_ANALYTICS'] = true;
      this.privileges['HC_CUSTOMER_CREATE_USER'] = false;
      this.privileges['HC_CUSTOMER_DELETE_USER'] = false;
      this.privileges['HC_CUSTOMER_UPDATE_USER'] = false;
      this.privileges['HC_CUSTOMER_VIEW_USER'] = false;
      this.userManagement = false;
      this.destinationLimitations = false;
      this.originLimitations = false;
    } else if (this.customerService.updatedCustomerUser.roleCode == "HC_CUSTOMER_ADHOC") {
      this.isAdhoc = true;
      this.privileges['HC_CUSTOMER_TRACKTRACE'] = true;
      this.privileges['HC_CUSTOMER_UNYSON_TRACKTRACE'] = false;
      this.privileges['HC_CUSTOMER_RATEREQUEST'] = false;
      this.privileges['HC_CUSTOMER_RATE_INQUIRY'] = false;
      this.privileges['HC_CUSTOMER_CREATE_ORDER'] = false;
      this.privileges['HC_CUSTOMER_CLAIMS'] = false;
      this.privileges['HC_CUSTOMER_ANALYTICS'] = false;
      this.privileges['HC_CUSTOMER_CREATE_USER'] = false;
      this.privileges['HC_CUSTOMER_DELETE_USER'] = false;
      this.privileges['HC_CUSTOMER_UPDATE_USER'] = false;
      this.privileges['HC_CUSTOMER_VIEW_USER'] = false;
      this.userManagement = false;
      this.destinationLimitations = false;
      this.originLimitations = false;
    } else if (this.customerService.updatedCustomerUser.roleCode == "HC_CUSTOMER_CLAIMS_USER") {
      this.isAdhoc = false;
      this.privileges['HC_CUSTOMER_TRACKTRACE'] = true;
      this.privileges['HC_CUSTOMER_UNYSON_TRACKTRACE'] = false;
      this.privileges['HC_CUSTOMER_RATEREQUEST'] = false;
      this.privileges['HC_CUSTOMER_RATE_INQUIRY'] = false;
      this.privileges['HC_CUSTOMER_CREATE_ORDER'] = false;
      this.privileges['HC_CUSTOMER_CLAIMS'] = true;
      this.privileges['HC_CUSTOMER_ANALYTICS'] = false;
      this.privileges['HC_CUSTOMER_CREATE_USER'] = false;
      this.privileges['HC_CUSTOMER_DELETE_USER'] = false;
      this.privileges['HC_CUSTOMER_UPDATE_USER'] = false;
      this.privileges['HC_CUSTOMER_VIEW_USER'] = false;
      this.userManagement = false;
      this.destinationLimitations = false;
      this.originLimitations = false;
    }
  }

  public toggleUserManagementChoices() {
    if (this.userManagement == true) {
      this.privileges['HC_CUSTOMER_CREATE_USER'] = true;
      this.privileges['HC_CUSTOMER_DELETE_USER'] = true;
      this.privileges['HC_CUSTOMER_UPDATE_USER'] = true;
      this.privileges['HC_CUSTOMER_VIEW_USER'] = true;
    } else {
      this.privileges['HC_CUSTOMER_CREATE_USER'] = false;
      this.privileges['HC_CUSTOMER_DELETE_USER'] = false;
      this.privileges['HC_CUSTOMER_UPDATE_USER'] = false;
      this.privileges['HC_CUSTOMER_VIEW_USER'] = false;
    }
  }

  public updateGeoPrivilegeSelected(event, type) {
    if (type === 'origin') {
      this.customerService.updatedCustomerUser.allowed_origin_locations = event;
      if (this.customerService.updatedCustomerUser.allowed_origin_locations.length) {
        this.originLimitations = true;
      } else {
        this.originLimitations = false;
      }
    } else if (type === 'destination') {
      this.customerService.updatedCustomerUser.allowed_destination_locations = event;
      if (this.customerService.updatedCustomerUser.allowed_destination_locations.length) {
        this.destinationLimitations = true;
      } else {
        this.destinationLimitations = false;
      }
    }
  }

  onSubmit() {
    let selectedPrivileges = [];

    let myObj = this.privileges;
    Object.keys(myObj).forEach(function (privilege) {
      if (myObj[privilege] == true) {
        selectedPrivileges.push(privilege);
      }
    });

    this.customerService.updatedCustomerUser.entitlements = selectedPrivileges;
    this.router.navigate(['../confirm-update'], { relativeTo: this.route, queryParams: { ID: this.customerUserID, customerID: this.customerId, urlPath: this.redirectUrl } });
  }

  private _searchSubscription: Subscription;
  public customerDD: any[] = [];

  /**
 * Setup Customer search
 * Observes the element with id "customer"
 * Waits 500 milliseconds before it sends filter request to back end
 */
  private _customerSearchSetup(): void {
    this._searchSubscription = Observable.fromEvent(document.getElementById('customerSearch'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      if (!searchText || !searchText.trim()) {
        this.customerDD = [];
        this.customerService.newCustomerUser.customerSearch = null;
        this.customerService.newCustomerUser.organization_id = null;
      } else {
        this._dropdownService.getDropdown(searchText, 'CUSTOMER').subscribe((result: any[]) => {
          this.customerDD = result;
        }, () => {
          this.flashMessageService.updateMessage('Failed to load customers.')
        });
      }

    });
  };

  private _loadCustomerDetails(custId: string) {
    this.loading = true;
    this._dropdownService.getDropdown(custId, 'CUSTOMER').subscribe((result: any[]) => {
      const customer = result[0];
      this.customerService.updatedCustomerUser.customerSearch = `${customer.name} - ${customer.id}`;
      this.customerService.updatedCustomerUser.organization.organizationCode = customer.id;
      this.loading = false;
    }, () => {
      this.flashMessageService.updateMessage('Failed to load customers.');
      this.loading = false;
    });
  }

  /**
   * Update fields on select customer dropdown
   * @param customerName
   * @param customerId
   */
  public selectCustomer(customer: any): void {
    this.assignRoleValues(customer.id);
    this.customerUpdate = customer;
    this.customerService.changeCustomer(customer);
    this.customerService.updatedCustomerUser.customerSearch = `${customer.name} - ${customer.id}`;
    this.customerDD = [];
  }

  ngOnDestroy(): void {
    if (this._searchSubscription) {
      this._searchSubscription.unsubscribe();
    }
  }

  private _formatLocation(locations) {
    let limitations = [];
    _.get(locations, 'states', []).forEach(state => {
      limitations.push({
        id: [state,'','state'],
        text: state
      });
    });
    _.get(locations, 'citystates', []).forEach(citystate => {
      limitations.push({
        id: [citystate, 'city_state'],
        text: citystate
      });
    });
    _.get(locations, 'zipcodes', []).forEach(zipcode => {
      limitations.push({
        id: [zipcode, '','zip_code'],
        text: zipcode
      });
    });
    _.get(locations, 'name', []).forEach(name => {
      limitations.push({
        id: [name, '', 'name'],
        text: name
      });
    });
    return limitations;
  }

}
